import React from 'react'
import classNames from 'classnames'
import { CaptionLG } from '@/atoms/Text'
import { useLocale } from '@/utils/LocaleUtil'

interface OwnersRemainingCaptionProps {
  totalNumberOfOwners?: number | null
}

export const OwnersRemainingCaption: React.FC<OwnersRemainingCaptionProps> = ({ totalNumberOfOwners }) => {
  return (
    <>
      <InternalOwnersRemainingCaption
        totalNumberOfOwners={totalNumberOfOwners}
        visibleOwnersForBreakpoint={7}
        breakpointVisibilityClasses="hidden 2xl:block"
      />
      <InternalOwnersRemainingCaption
        totalNumberOfOwners={totalNumberOfOwners}
        visibleOwnersForBreakpoint={6}
        breakpointVisibilityClasses="sm:hidden"
      />
      <InternalOwnersRemainingCaption
        totalNumberOfOwners={totalNumberOfOwners}
        visibleOwnersForBreakpoint={2}
        breakpointVisibilityClasses="hidden sm:block lg:hidden"
      />
      <InternalOwnersRemainingCaption
        totalNumberOfOwners={totalNumberOfOwners}
        visibleOwnersForBreakpoint={5}
        breakpointVisibilityClasses="hidden lg:block xl:hidden"
      />
      <InternalOwnersRemainingCaption
        totalNumberOfOwners={totalNumberOfOwners}
        visibleOwnersForBreakpoint={6}
        breakpointVisibilityClasses="hidden xl:block 2xl:hidden"
      />
    </>
  )
}

interface InternalOwnersRemainingCaptionProps {
  totalNumberOfOwners?: number | null
  visibleOwnersForBreakpoint: number
  breakpointVisibilityClasses?: string
}

export const InternalOwnersRemainingCaption: React.FC<InternalOwnersRemainingCaptionProps> = ({
  totalNumberOfOwners,
  visibleOwnersForBreakpoint,
  breakpointVisibilityClasses,
}) => {
  const { locale } = useLocale()
  const remainingOwners = (totalNumberOfOwners ?? 0) - visibleOwnersForBreakpoint

  if (remainingOwners <= 0) return null

  return (
    <CaptionLG color="white" weight="bold" className={classNames('ml-3 shrink-0', breakpointVisibilityClasses)}>
      +{Intl.NumberFormat(locale, { notation: 'compact', compactDisplay: 'short' }).format(remainingOwners)}
    </CaptionLG>
  )
}
